"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PScriptPurpose = void 0;
var pstruct_1 = require("../../../../PTypes/PStruct/pstruct.js");
var PStakingCredential_1 = require("../../Address/PStakingCredential.js");
var PDCert_1 = require("../../PDCert/index.js");
var PTxOutRef_1 = require("../../Tx/PTxOutRef.js");
var PCurrencySymbol_1 = require("../../Value/PCurrencySymbol.js");
exports.PScriptPurpose = (0, pstruct_1.pstruct)({
    Minting: { currencySym: PCurrencySymbol_1.PCurrencySymbol.type },
    Spending: { utxoRef: PTxOutRef_1.PTxOutRef.type },
    Rewarding: { stakeCredential: PStakingCredential_1.PStakingCredential.type },
    Certifying: { dCert: PDCert_1.PDCert.type }
});
